export default [
    {
        path: '/admin/academic/level-skill-subjects',
        name: 'level-skill-subject',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/level-skill-subject/index.vue')
    },
    {
        path: '/admin/academic/level-skill-subjects/create',
        name: 'level-skill-subject-create',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/level-skill-subject/create.vue')
    },
    {
        path: '/admin/academic/level-skill-subjects/edit',
        name: 'level-skill-subject-edit',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/level-skill-subject/edit.vue')
    },
]
